import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Inject, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@upr-web-primer/locale';
import { LocaleModule } from '@upr-web-primer/locale';
import { WINDOW, WindowModule } from '@upr-web-primer/window';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

class GoogleRecaptchaService {
    constructor() {
        this.reset$ = new Subject();
    }
    reset() {
        this.reset$.next(true);
    }
}
GoogleRecaptchaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GoogleRecaptchaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

let count = 0;
class GoogleRecaptchaComponent {
    constructor(zone, captchaService, localeService, window, config) {
        this.zone = zone;
        this.captchaService = captchaService;
        this.localeService = localeService;
        this.window = window;
        this.config = config;
        this.response = new EventEmitter();
        this.id = count++;
        this.language = this.localeService.getFromStorage().language;
        this.captchaService.reset$.subscribe(() => {
            this.reset();
        });
    }
    ngOnInit() {
        document.getElementById('grecaptcha')
            ? this.render()
            : this.loadCaptchaScript();
    }
    loadCaptchaScript() {
        this.window.recaptchaCallback = () => {
            this.render();
        };
        const script = document.createElement('script');
        const language = this.language ? `&hl=${this.language}` : '';
        script.src = `${this.config.apiUrl}?onload=recaptchaCallback&render=explicit${language}`;
        script.async = true;
        script.defer = true;
        script.id = this.recaptcha.nativeElement;
        document.body.appendChild(script);
    }
    render() {
        if (grecaptcha && typeof grecaptcha.render === 'function') {
            this.recaptchaId = grecaptcha.render(this.recaptcha.nativeElement.id, {
                sitekey: this.config.siteKey,
                callback: (res) => {
                    this.zone.run(() => {
                        this.response.emit(res);
                    });
                },
                'expired-callback': () => {
                    this.reset();
                }
            });
        }
        else {
            setTimeout(() => {
                this.render();
            }, 5000);
        }
    }
    ngOnDestroy() {
        this.zone.run(() => {
            if (grecaptcha) {
                grecaptcha.reset(this.recaptchaId);
            }
        });
    }
    reset() {
        this.zone.run(() => {
            if (grecaptcha) {
                grecaptcha.reset(this.recaptchaId);
                this.response.emit('');
            }
        });
    }
}
GoogleRecaptchaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaComponent, deps: [{ token: i0.NgZone }, { token: GoogleRecaptchaService }, { token: i2.LocaleService }, { token: WINDOW }, { token: 'RecaptchaConfig' }], target: i0.ɵɵFactoryTarget.Component });
GoogleRecaptchaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: GoogleRecaptchaComponent, selector: "upr-google-recaptcha", outputs: { response: "response" }, viewQueries: [{ propertyName: "recaptcha", first: true, predicate: ["recaptcha"], descendants: true, static: true }], ngImport: i0, template: "<div #recaptcha class=\"g-recaptcha\" id=\"google-recaptcha-{{ id }}\"></div>\r\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-google-recaptcha', template: "<div #recaptcha class=\"g-recaptcha\" id=\"google-recaptcha-{{ id }}\"></div>\r\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: GoogleRecaptchaService }, { type: i2.LocaleService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['RecaptchaConfig']
                }] }]; }, propDecorators: { response: [{
                type: Output
            }], recaptcha: [{
                type: ViewChild,
                args: ['recaptcha', { static: true }]
            }] } });

class GoogleRecaptchaModule {
}
GoogleRecaptchaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GoogleRecaptchaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaModule, declarations: [GoogleRecaptchaComponent], imports: [CommonModule, WindowModule, LocaleModule], exports: [GoogleRecaptchaComponent] });
GoogleRecaptchaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaModule, imports: [[CommonModule, WindowModule, LocaleModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleRecaptchaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, WindowModule, LocaleModule],
                    declarations: [GoogleRecaptchaComponent],
                    exports: [GoogleRecaptchaComponent]
                }]
        }] });

export { GoogleRecaptchaComponent, GoogleRecaptchaModule, GoogleRecaptchaService };
